import React, { useEffect, useState } from "react";
import cameraIcon from "../../assets/svg/CameraIcon.svg";
import axios from "axios";
import { newHost } from "../../pages/Categories/CategoryProfile";
import { newImageUrl } from "../../pages/Manufacturers/ManufactureProfile";
import { useLocation, useNavigate, useParams } from "react-router";
import { toast } from "react-toastify";
import defaultImage from "../../assets/svg/defultImage.svg";
import { Box, Dialog, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
const ImageAfter = () => {
  const token = sessionStorage.getItem("token");
  const { id: orderId } = useParams();

  const [configs, setConfigs] = useState([]);
  const [imagesAfter, setImagesAfter] = useState([]);
  const [imageAfterPreview, setImageAfterPreview] = useState({});
  const [uploadedImagesAfter, setUploadedImagesAfter] = useState([]);
  const [loadingImagesAfter, setLoadingImagesAfter] = useState(true);
  const [openImage, setOpenImage] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const FileChangeImagesAfter = (e, configId) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();

    reader.onloadend = () => {
      setImageAfterPreview((prev) => ({
        ...prev,
        [configId]: reader.result,
      }));

      setUploadedImagesAfter((prev) => ({
        ...prev,
        [configId]: file,
      }));
    };

    reader.readAsDataURL(file);
  };
  const getImagesConfig = async () => {
    try {
      const response = await axios.get(`${newHost}stuff/get-configs`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setConfigs(response.data.data?.configs);
    } catch (error) {
      console.log(error.response);
    }
  };

  const getImagesAfter = async () => {
    try {
      const response = await axios.get(
        `${newHost}stuff/get-after-images/${orderId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      setImagesAfter(response.data.data?.images_after || []);
    } catch (error) {
      console.log(error.response);
    } finally {
      setLoadingImagesAfter(false);
    }
  };

  useEffect(() => {
    getImagesConfig();
    getImagesAfter();
  }, []);

  const handleSubmitImagesAfter = async () => {
    const formData = new FormData();

    let index = 0;

    configs.forEach((config) => {
      const file = uploadedImagesAfter[config.id];

      if (file) {
        formData.append(`configs[${index}][id]`, config.id);

        formData.append(`configs[${index}][after_image]`, file);

        index++;
      }
    });
    try {
      const response = await axios.post(
        `${newHost}stuff/upload-after-images/${orderId}`,
        formData,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      toast.success(response.data?.message);
      navigate(`/ordersExecution/executeByService/${orderId}`, {});
    } catch (error) {
      toast.error(error.response.data.errors?.message);
    }
  };

  const location = useLocation();

  const navigate = useNavigate();

  const totalConfigs = configs.length;
  const uploadedAfterCount = Object.keys(uploadedImagesAfter).length;

  return (
    <div className="m-4" dir="rtl">
      <div className="my-2">
        {loadingImagesAfter && (
          <div className="text-center my-5">Loading...</div>
        )}
        {imagesAfter.length > 0 ? (
          <>
            <div className="">
              <h6 className="main-text-color">
                صور خاصة بالسيارة بعد تنفيذ الخدمات
              </h6>
              <div className="row my-2 min-vh-100">
                {imagesAfter.map((img) => (
                  <div key={img.id} className="col-md-2 col-12">
                    <label
                      htmlFor={`profile_photo_${img.id}`}
                      className="w-100 my-2 text-center"
                    >
                      {img?.config?.label_ar}

                      <div
                        style={{
                          width: "100%",
                          height: "120px",
                          cursor: "pointer",
                          borderRadius: "15px",
                        }}
                      >
                        <img
                          src={
                            img.image_url
                              ? `${newImageUrl}${img?.image_url}`
                              : defaultImage
                          }
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "fill",
                            borderRadius: "15px",
                          }}
                          onClick={() => {
                            setSelectedImage(

                              `${newImageUrl}${img?.image_url}`

                            );
                            setOpenImage(true);
                          }}
                        />
                      </div>
                    </label>
                  </div>
                ))}
              </div>
            </div>
            <Dialog
              open={openImage}
              onClose={() => setOpenImage(false)}
              fullScreen
              PaperProps={{
                sx: {
                  backgroundColor: "rgba(0,0,0,0.95)",
                },
              }}
            >
              <IconButton
                onClick={() => setOpenImage(false)}
                sx={{
                  position: "absolute",
                  top: 16,
                  right: 16,
                  color: "#fff",
                  zIndex: 10,
                }}
              >
                <CloseIcon fontSize="large" />
              </IconButton>
              <IconButton
                onClick={() => setOpenImage(false)}
                sx={{
                  position: "absolute",
                  top: 16,
                  left: 16,
                  color: "#fff",
                  zIndex: 10,
                }}
              >
                <ArrowBackIcon fontSize="large" />
              </IconButton>

              <Box
                sx={{
                  width: "100vw",
                  height: "100vh",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <img
                  src={selectedImage}
                  alt=""
                  style={{
                    width: "70%",
                    maxHeight: "500px",
                    objectFit: "fill"
                  }}
                />
              </Box>
            </Dialog>
          </>
        ) : (
          <>
            <div className="">
              <h6 className="main-text-color">
                اضافة صور خاصة بالسيارة بعد تنفيذ الخدمات
              </h6>
              <div className="row my-2 min-vh-100">
                {configs.map((config) => (
                  <div key={config.id} className="col-md-2 col-12">
                    <label
                      htmlFor={`profile_photo_${config.id}`}
                      className="w-100 my-2 text-center"
                    >
                      {config?.label_ar}
                      <input
                        type="file"
                        id={`profile_photo_${config.id}`}
                        className="d-none"
                        onChange={(e) => FileChangeImagesAfter(e, config.id)}
                      />

                      {imageAfterPreview[config.id] ? (
                        <div
                          style={{
                            width: "100%",
                            height: "120px",
                            cursor: "pointer",
                            borderRadius: "15px",
                          }}
                        >
                          <img
                            src={imageAfterPreview[config.id]}
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "fill",
                              borderRadius: "15px",
                            }}
                          />
                        </div>
                      ) : (
                        <div
                          style={{
                            border: "dashed 1px #C6C6C6",
                            width: "100%",
                            height: "120px",
                            cursor: "pointer",
                            borderRadius: "15px",
                          }}
                          className="d-flex flex-column justify-content-center align-items-center my-1 p-2"
                        >
                          <img src={cameraIcon} style={{ width: "40px" }} />
                          <p className="main-text-color label-size m-0">
                            Add Image
                          </p>
                        </div>
                      )}
                    </label>
                  </div>
                ))}
              </div>
              <div className="d-flex justify-content-center fixed-footer">
                <button
                  onClick={handleSubmitImagesAfter}
                  className="btn btn-dark px-5 d-flex gap-1"
                  style={{
                    cursor: "pointer",
                  }}
                >
                  {`حفظ ${uploadedAfterCount} من ${totalConfigs}`}
                </button>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ImageAfter;
